import { Box, useTheme } from '@chakra-ui/react';

const FooterLinkDivider = (props) => {
  const theme = useTheme();
  return <Box color={theme.colors.mediumGrey3} margin='0 15px' {...props} />;
};

export default FooterLinkDivider;
